import { render } from "./ErrorPaymentInfo.vue?vue&type=template&id=168e1301&scoped=true"
import script from "./ErrorPaymentInfo.vue?vue&type=script&lang=js"
export * from "./ErrorPaymentInfo.vue?vue&type=script&lang=js"

import "./ErrorPaymentInfo.vue?vue&type=style&index=0&id=168e1301&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-168e1301"

export default script